import { ContactModal } from "@/components/common/contact-modal";
import { cn } from "@/lib/utils";
import { pushModal } from "@/stores/modal";
import { Button } from "@/styles/ui/button";

export const ContactButton = ({
  className,
  text,
}: {
  className?: string;
  text?: string;
}) => {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn(
        "!border-none shadow-none text-[14px] font-weight-normal line-height-[20px] letter-spacing-[0.203px] underline p-0 ",
        className,
      )}
      onClick={() => {
        pushModal(ContactModal);
      }}
    >
      {text || "문의하기"}
    </Button>
  );
};
